import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'
import { authApi } from 'shared/api/auth'

import { ActivateRequest, ActivateResponse } from './activate.types'

export const activate = async (request: ActivateRequest) => {
  const response = await authApi.get<ActivateResponse>(
    `/innos/activate/${request.token}`
  )

  return response.data
}

export const ACTIVATE_QUERY_KEY = 'activate'

export const useActivateQuery = (
  request: ActivateRequest,
  options?: ExtendableQueryOptions<ActivateResponse>
) => {
  return useQuery({
    queryKey: [ACTIVATE_QUERY_KEY, request.token],
    queryFn: () => activate(request),
    ...options
  })
}
